import React, { useState, useEffect } from 'react'

import IconButton from '../../elements/IconButton'
import Button from '../../elements/Button'
import TextInput from '../../elements/TextInput'

const Main = (props) => {
    const [bonusAmount, setBonusAmount] = useState('')
    const [weeklyNet, setWeeklyNet] = useState('')
    const [bringMonthToPaid, setBringMonthToPaid] = useState('')

    const week = props.selectedAgent?.weeks?.[props.selectedWeekNum]

    // Start each field at the amount already saved for this week
    useEffect(() => {
        setWeeklyNet(week?.paid_amount ?? '')
        setBringMonthToPaid(week?.bmt_paid_amount ?? '')
        setBonusAmount(week?.bonuses_paid_amount ?? '')
    }, [props.isOpen, props.selectedWeekNum, props.selectedAgent])

    // Only a changed, valid amount is sent. An empty box leaves the saved amount alone.
    const changedValue = (value, saved) => {
        const text = String(value).trim()
        if (text === '' || isNaN(Number(text))) return ''

        return Number(text) === Number(saved ?? 0) ? '':text
    }

    const submitData = () => {
        const paid = changedValue(weeklyNet, week?.paid_amount)
        const bmt = changedValue(bringMonthToPaid, week?.bmt_paid_amount)
        const bonus = changedValue(bonusAmount, week?.bonuses_paid_amount)

        if (paid === '' && bmt === '' && bonus === '') {props.setIsOpen(); return}

        props.editWeeklyValue(props.selectedWeekNum, paid, bmt, bonus)
    }

    return (
        <div style={{width: '600px', height: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Edit Amounts</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px'}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <div>
                    <div style={{marginTop: '20px'}}>
                        <span style={{fontWeight: '600'}}>Previous Week</span>
                    </div>
                    {(() => {
                        const week = props.selectedAgent?.weeks?.[props.selectedWeekNum - 1]

                        return week ? (
                            <div style={{display: 'flex', flexDirection: 'column', marginTop: '0px'}}>
                                <span>Paid Amount: {week.paid_amount}</span>
                                <span>Notes: {week.paid_amount_notes}</span>
                            </div>
                        ) : (
                            <div style={{marginTop: '20px'}}>
                                <span>No previous week. Please select a different month.</span>
                            </div>
                        )
                    })()}
                </div>
                <div>
                    <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '20px'}}>
                        <span>Paid</span>
                        <TextInput
                            colors={props.colors}
                            data={weeklyNet}
                            onChange={(value) => setWeeklyNet(value) }
                            Style={{marginTop: '5px'}}
                        ></TextInput>
                    </div>
                    <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '10px'}}>
                        <span>Bring Month To Paid</span>
                        <TextInput
                            colors={props.colors}
                            data={bringMonthToPaid}
                            onChange={(value) => setBringMonthToPaid(value)}
                            Style={{marginTop: '5px'}}
                        ></TextInput>
                    </div>
                    <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '10px'}}>
                        <span>Bonuses Paid</span>
                        <TextInput
                            colors={props.colors}
                            data={bonusAmount}
                            onChange={(value) => setBonusAmount(value)}
                            Style={{marginTop: '5px'}}
                        ></TextInput>
                    </div>
                </div>
            </div>
            
            <Button colors={props.colors} onClick={() => submitData()} Style={{backgroundColor: props.colors.primary, color: props.colors.fontInvert, marginTop: '20px'}}>Save</Button>
        </div>
    )
}

export default Main
